import { render } from "./ValueMapLabels.vue?vue&type=template&id=78c90bf1"
import script from "./ValueMapLabels.vue?vue&type=script&lang=js"
export * from "./ValueMapLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__